import React, { useEffect, useState } from "react";

import { Loader2 } from "lucide-react";

import { Button } from "~/components/ui/button";
import { supabase } from "~/integrations/supabase/client";

interface BSaleDocumentButtonProps {
  bsaleNumber: number;
  onOpenSalesRequest?: (salesRequestId: string) => void;
}

interface SalesRequestDocument {
  id: string;
  sales_request_id: string;
  bsale_number: string;
}

const BSaleDocumentButton: React.FC<BSaleDocumentButtonProps> = ({
  bsaleNumber,
  onOpenSalesRequest,
}) => {
  const [salesRequestDocument, setSalesRequestDocument] =
    useState<SalesRequestDocument | null>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchSalesRequestDocument = async () => {
      setLoading(true);
      setNotFound(false);

      try {
        const { data, error } = await supabase
          .from("sales_request_documents")
          .select("id, sales_request_id, bsale_number")
          .eq("bsale_number", bsaleNumber.toString())
          .single();
        if (error || !data) {
          setNotFound(true);
          setSalesRequestDocument(null);
        } else {
          setSalesRequestDocument(data);
          setNotFound(false);
        }
      } catch (error) {
        console.error("Error fetching sales request document:", error);
        setNotFound(true);
        setSalesRequestDocument(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSalesRequestDocument();
  }, [bsaleNumber]);

  const handleClick = () => {
    if (salesRequestDocument && onOpenSalesRequest) {
      onOpenSalesRequest(salesRequestDocument.sales_request_id);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-1 text-sm text-muted-foreground">
        <Loader2 className="h-3 w-3 animate-spin" />
        <span>Buscando...</span>
      </div>
    );
  }

  if (notFound || !salesRequestDocument) {
    return (
      <span className="text-sm font-medium text-red-500">No asociado a NV</span>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      className="border-blue-200 text-blue-600 hover:bg-blue-50"
    >
      NV #{salesRequestDocument.sales_request_id?.slice(-8) || "N/A"}
    </Button>
  );
};

export default BSaleDocumentButton;
